import { render, staticRenderFns } from "./SearchUserItem.vue?vue&type=template&id=3b90f460&"
import script from "./SearchUserItem.vue?vue&type=script&lang=ts&"
export * from "./SearchUserItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports